<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row align-items-end pt-2">
              <filter-component
                @filter="handleFilter"
                @onChangeFilters="handleFilterChange"
                @showHideLoading="showHideLoading"
                :filterOfLots="canShow"
                :isMultipleFarms="false"
                :isRequiredFarms="true"
                :isRequiredLots="false"
                :classFarms="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classLots="`col-12 col-md-6 col-lg-5 col-xl-4`"
              >
                <template slot="prev">
                  <div class="col-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                    <label>{{ $t('common_words.report_type') }}: * </label>
                    <br />
                    <el-select
                      clearable
                      filterable
                      @change="showLotByReportType()"
                      v-model="model.report_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm required-report"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in report_type"
                        :key="item.id + item.name"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div
          v-if="haveData"
          class="row mx-1 d-flex flex-wrap justify-content-between align-items-center"
        >
          <div class="p-0 pr-1 m-0 col-12 col-md-12 col-lg-6">
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLineExprecting"></highcharts>
                </div>
              </div>
            </card>
          </div>
          <div class="p-0 pl-1 m-0 col-12 col-md-12 col-lg-6">
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLine"></highcharts>
                </div>
              </div>
            </card>
          </div>
          <div
            v-if="reportTable[0].youngPlants"
            class="p-0 pl-1 m-0 col-12 col-md-12 col-lg-12"
          >
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLineYoung"></highcharts>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
      <div v-if="isIndex()">
        <div v-if="haveData">
          <card
            class="custom-shadow-card-header"
            :title="$t('sigatoka.sigatoka_capture_report')"
          >
            <div class="row w-100 pl-3">
              <div class="custom-scroll-table-wrapper w-100">
                <table class="table table-striped table-bordered mt-3 w-100">
                  <thead>
                    <tr class="cusmtom-thead-color">
                      <th
                        rowspan="3"
                        :style="hasLot ? 'min-width: 160px' : 'min-width: 85px'"
                        class="text-center p-3 custom-header-label sticky-header"
                      >
                        {{
                          this.hasLot
                            ? $t('common_words.date') +
                              ' - ' +
                              $t('common_words.allotment')
                            : $t('common_words.date')
                        }}
                      </th>
                      <th
                        v-for="f in farm"
                        :key="f.id"
                        :colspan="columnCount"
                        style="min-width: 85px"
                        class="text-center p-3 custom-header-label sticky-header"
                      >
                        {{ f.name }}
                      </th>
                    </tr>
                    <tr class="cusmtom-thead-color">
                      <th
                        v-for="age in ages"
                        :key="age"
                        style="min-width: 85px"
                        :colspan="getAgeColspan(age)"
                        class="text-center p-3 custom-header-label sticky-header"
                      >
                        {{
                          age === 0
                            ? $t('sigatoka.expecting')
                            : age === 1
                            ? $t('sigatoka.newly_given_birth')
                            : age === 6 && reportTable[0].change_label
                            ? $t('sigatoka.young_6_weeks')
                            : age + ' ' + $t('common_words.weeks')
                        }}
                      </th>
                      <th
                        v-if="reportTable[0].youngPlants"
                        style="min-width: 85px"
                        :colspan="youngColspan"
                        class="text-center p-3 custom-header-label sticky-header"
                      >
                        {{ $t('sigatoka.young_plants') }}
                      </th>
                    </tr>
                    <tr class="cusmtom-thead-color">
                      <template v-for="age in ages">
                        <th
                          v-for="metric in metricsByAge(age)"
                          :key="age + '-' + metric"
                          style="min-width: 85px"
                          class="text-center p-3 custom-header-label sticky-header"
                        >
                          {{ metric.toUpperCase() }}
                        </th>
                      </template>
                      <th
                        v-if="reportTable[0].youngPlants"
                        class="text-center p-3 custom-header-label sticky-header"
                        style="min-width: 85px"
                      >
                        {{ $t('sigatoka.total_functional_leaves') }}
                      </th>
                      <th
                        v-if="reportTable[0].youngPlants"
                        class="text-center p-3 custom-header-label sticky-header"
                        style="min-width: 85px"
                      >
                        {{ $t('sigatoka.ref') }}
                      </th>
                      <th
                        v-if="reportTable[0].youngPlants"
                        v-for="leaf in youngData()"
                        :key="leaf"
                        style="min-width: 85px"
                        class="text-center p-3 custom-header-label sticky-header"
                      >
                        {{ $t('sigatoka.leaf') }} {{ leaf }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rows" :key="row.key">
                      <td class="text-center">
                        {{ row.label }}
                      </td>
                      <template v-for="cell in row.values">
                        <td
                          class="text-center"
                          v-if="cell.total_leaves !== undefined"
                        >
                          {{ cell.total_leaves }}
                        </td>
                        <td class="text-center" v-if="cell.yls !== undefined">
                          {{ cell.yls }}
                        </td>
                        <td class="text-center" v-if="cell.yli !== undefined">
                          {{ cell.yli }}
                        </td>
                        <td
                          v-if="
                            reportTable[0].youngPlants &&
                            cell.functional_leaf !== undefined
                          "
                          class="text-center"
                        >
                          {{ cell.functional_leaf }}
                        </td>
                        <td
                          v-if="
                            reportTable[0].youngPlants && cell.ref !== undefined
                          "
                          class="text-center"
                        >
                          {{ cell.ref }}
                        </td>
                        <td
                          v-if="
                            reportTable[0].youngPlants &&
                            cell.leaves !== undefined
                          "
                          v-for="leaf in cell.leaves"
                          class="text-center"
                        >
                          {{ leaf }}
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <export-tables class="mb-3" :pdf="pdf" :xls="xls" />
          </card>
        </div>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { Chart } from 'highcharts-vue';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import { isset, getDateToday } from 'src/util/Util';
import Filter from 'src/components/Filter/Filters.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import ExportTables from 'src/components/Tables/ExportTables.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinMenu,
    MixinCharts,
    MixinMasters,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [ExportTables.name]: ExportTables,
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      lots: [],
      farms: [],
      reportLine: [],
      canShow: false,
      haveData: false,
      reportTable: [],
      isDetailed: false,
      valueCollapse: null,
      reportLineYoung: [],
      activeName: 'filter',
      reportLineExprecting: [],
      model: {
        year: null,
        lot_id: [],
        farm_id: null,
        report_id: null,
      },
    };
  },
  computed: {
    pdf() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_capture_report')}_${
          this.dateToday
        }.pdf`,
        route: 'sigatoka/capture/pdf',
        paramMethod: 'POST',
        plusData: {
          data: this.reportTable,
        },
      };
    },
    xls() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_capture_report')}_${
          this.dateToday
        }.xlsx`,
        route: 'sigatoka/capture/excel',
        paramMethod: 'POST',
        plusData: {
          data: this.reportTable,
        },
      };
    },
    dateToday() {
      return getDateToday();
    },
    report_type() {
      return [
        {
          id: 2,
          name: i18n.t('common_words.detailed'),
        },
        {
          id: 1,
          name: i18n.t('common_words.consolidated'),
        },
      ];
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    ages() {
      if (!this.reportTable.length) return [];
      return this.reportTable[0].ages || [];
    },
    farm() {
      if (!this.reportTable.length) return;
      const farm = {};
      this.reportTable.forEach((item) => {
        farm[item.farm.id] = item.farm;
      });

      return Object.values(farm);
    },
    hasLot() {
      if (!this.reportTable.length) return;

      return this.reportTable.some((item) => item.lot);
    },
    columnCount() {
      let column = this.ages.some((age) => this.showYliMetric(age)) ? 7 : 6;
      column = this.ages.length > 3 ? column + 2 : column;
      if (this.reportTable.youngPlants == []) return column;
      let leavesLength = Object.keys(
        this.reportTable[0].youngPlants.leaves
      ).length;
      return column + 2 + leavesLength;
    },
    youngColspan() {
      return Object.keys(this.reportTable[0].youngPlants.leaves).length + 2;
    },
    rows() {
      if (!this.reportTable.length) return;

      return this.reportTable.map((item) => {
        return {
          key:
            this.isDetailed && item.lot
              ? `${item.date} - ${item.lot.id}`
              : `${item.date}`,
          label:
            this.isDetailed && item.lot
              ? `${item.date} - ${item.lot.name}`
              : `${item.date}`,
          values: this.rowValues(item),
        };
      });
    },
  },
  methods: {
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.getData();
    },
    handleFilterChange() {
      this.haveData = false;
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    showLotByReportType() {
      this.haveData = false;
      this.model.report_id == 2 ? (this.canShow = true) : this.cleanLot();
    },
    cleanLot() {
      this.model.lot_id = [];
      this.canShow = false;
    },
    rowValues(item) {
      const values = [];
      this.ages.forEach((age) => {
        const found = item.totals.find((t) => t.age === age);
        if (found == undefined)
          if (this.showYliMetric(age))
            values.push({
              total_leaves: 0,
              yls: 0,
              yli: 0,
            });
          else
            values.push({
              total_leaves: 0,
              yls: 0,
            });
        else {
          if (this.showYliMetric(age))
            values.push({
              total_leaves: found.metrics.total_leaves,
              yls: found.metrics.yls,
              yli: found.metrics.yli,
            });
          else
            values.push({
              total_leaves: found.metrics.total_leaves,
              yls: found.metrics.yls,
            });
        }
      });
      if (this.reportTable[0].youngPlants)
        values.push({
          functional_leaf: item.youngPlants.functional_leaf,
          ref: item.youngPlants.ref,
          leaves: item.youngPlants.leaves,
        });

      return values;
    },
    getAgeColspan(age) {
      return this.showYliMetric(age) ? 3 : 2;
    },
    metricsByAge(age) {
      if (this.showYliMetric(age))
        return [
          i18n.t('sigatoka.total_functional_leaves'),
          i18n.t('sigatoka.yls'),
          i18n.t('sigatoka.yli'),
        ];

      return [
        i18n.t('sigatoka.total_functional_leaves'),
        i18n.t('sigatoka.yls'),
      ];
    },
    youngData() {
      const leaf = this.reportTable[0].youngPlants.leaves;
      return Object.keys(leaf).map(Number);
    },
    showYliMetric(age) {
      return (
        age === 0 ||
        (this.reportTable.length &&
          this.reportTable[0].change_label &&
          age === 6)
      );
    },
    validate() {
      if (!isset(this.model.report_id))
        return this.validationInputsRequired('report');
    },
    async getReport() {
      this.showHideLoading(true);
      const data = this.dataFilter;
      data.report_id = this.model.report_id;
      data.route = 'sigatoka/capture/filterdata';
      const responseReport = await Promise.all([Axios.postMasters(data)]).catch(
        (error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        }
      );

      if (!responseReport[0] || !responseReport[0].data.data) {
        this.showHideLoading();
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        return [];
      }
      return responseReport[0].data.data;
    },
    setData(response) {
      this.model.report_id == 2
        ? (this.isDetailed = true)
        : (this.isDetailed = false);
      this.reportTable = response.formatTable;
      this.reportLine = this.lines(response.formatLineChart);
      this.reportLineExprecting = this.lines(response.formatLineChartExpecting);
      this.reportLineYoung = this.lines(response.formatLineChartYoungPlants);
      this.haveData = true;

      this.showHideLoading();
    },
    async getData() {
      if (this.isIndex()) {
        if (this.validate()) return;
        const response = await this.getReport();
        if (response.length === 0) return;
        this.setData(response);
      } else this.showHideLoading();
    },
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
</style>
